import type { RefObject } from 'react'
import { TrayGrid } from '@components/app/panels/right-panel/tray'
import type { PortraitStudent } from '@/api/types/portrait'
import { formatPortraitStudentName } from '@/lib/portraits/portrait-student-names'
import { trayThumbnailBoxClassName } from '@/lib/tray/tray-thumbnail-box'

type PortraitsGalleryProps = {
  /** The students to show now: the window `useTrayLazyWindow` has grown to so far. */
  students: PortraitStudent[]
  sentinelRef: RefObject<HTMLDivElement | null>
  hasMore: boolean
}

/** The matching students, in the order given (closest match first), two per row like the other
 *  trays. Name-only tiles until the portrait thumbnails land. */
export function PortraitsGallery({ students, sentinelRef, hasMore }: PortraitsGalleryProps) {
  return (
    <TrayGrid columns={2} sentinelRef={sentinelRef} showSentinel={hasMore}>
      {students.map((student) => (
        <div
          key={student.portraitId}
          data-portrait-id={student.portraitId}
          className={`${trayThumbnailBoxClassName(2)} flex w-full items-end rounded-lg border border-border bg-background p-2`}
        >
          <span className="line-clamp-2 text-xs text-foreground">
            {formatPortraitStudentName(student) || 'Unnamed student'}
          </span>
        </div>
      ))}
    </TrayGrid>
  )
}
